import React, { useState } from "react";
import { VscEye } from "react-icons/vsc";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

// redux
import { Creators as AuthActions } from "store/ducks/auth";

// components
import { Menu, UserInfoModal } from "./components";

// assets
import Logo from "assets/images/logo_leroy.png";

function TopBar({ user, logoutRequest }) {
  const [openUserModal, setOpenUserModal] = useState(false);

  const handleLogout = (e) => {
    e.preventDefault();
    logoutRequest();
  };

  const handleOpenUserModal = () => {
    setOpenUserModal(true);
  };

  function handleCloseUserModal() {
    setOpenUserModal(false);
  }

  return (
    <div id="topbar">
      <div className="wrapper">
        <div className="topbar-logo">
          <Menu />

          <div className="logo">
            <img src={Logo} alt="Leroy Merlin com Você!" />
          </div>
        </div>

        {user.data.id && (
          <div className="topbar-options hide-on-print">
            <span className="user-info">
              Olá,
              <button type="button" onClick={handleOpenUserModal}>
                {user.data.attributes.name}
                <VscEye />
              </button>
              |
            </span>
            <a href="/#" className="logout" onClick={handleLogout}>
              Sair
            </a>

            <UserInfoModal
              user={user}
              isOpen={openUserModal}
              onRequestClose={handleCloseUserModal}
            />
          </div>
        )}
      </div>
    </div>
  );
}

const mapState = (state) => ({
  auth: state.auth,
  user: state.auth.user,
});

const mapActions = (dispatch) => bindActionCreators(AuthActions, dispatch);

export default connect(mapState, mapActions)(TopBar);
